
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/page/[id]",
      function () {
        return require("private-next-pages/news/page/[id].tsx");
      }
    ]);
  